import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import {
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import InformationForm from '../modules/InformationForm';
import { fetchInformationDetail } from '../modules/InformationDetail/actions';
import { isLoaded, getError } from '../modules/InformationDetail/selectors';
import { deleteInformation } from '../modules/InformationList/actions';
import { INFORMATION_FORM_NAME } from '../modules/InformationForm/constants';

class EditInformationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchInformationDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteInformation = () => {
    const { id, lang } = this.props.match.params;
    this.props.deleteInformation(id, lang, () => {
      this.toggle();
      this.props.history.push('/informace');
    });
  };

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, informationInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...informationInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit informaci</h1>
              <Button onClick={this.toggle} color="danger">
                Smazat tuto mutaci
              </Button>
            </PageNav>
            <InformationForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
              backdrop={this.state.backdrop}
            >
              <ModalHeader toggle={this.toggle}>Smazat</ModalHeader>
              <ModalBody>
                Opravdu chcete tuto mutaci užitečné informace smazat?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={this.deleteInformation}>
                  Smazat
                </Button>{' '}
                <Button color="secondary" onClick={this.toggle}>
                  Zrušit
                </Button>
              </ModalFooter>
            </Modal>
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    informationInitialValues: getFormValues(INFORMATION_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchInformationDetail, deleteInformation }
)(EditInformationPage);



// WEBPACK FOOTER //
// ./src/pages/EditInformationPage.js